import { useFeedbackDraftStore } from "@asurion-core/expert-workspace-feedback";
import { useNotification } from "@expert/common-ui";

export const useFeedbackNotification = () => {
    const notification = useNotification();
    const { draft } = useFeedbackDraftStore();

    return (type: "success" | "error") => {
        if (type === "success" && draft.description) {
            notification.success("Feedback saved");
        } else if (type === "error") {
            notification.error("Oops, there was an issue sending feedback. Try again—we saved your progress.");
        }
    };
};
